module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-sidebar",
    style: ({
      height: 'auto'
    })
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "ad_item"
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "width": "258",
        "height": "180",
        "alt": item.aname
      }
    })])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fbb3dc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/fresh-agricultural/banner-right-flow.vue
// module id = 1603
// module chunks = 1